import {
  ColorLight,
  HeatProfileDtoV1,
  MoodLightDto,
  MoodLightId,
} from 'puffco-api-axios-client';

export type Light = ColorLight | MoodLightId;

export interface HeatProfile extends Omit<HeatProfileDtoV1, 'light'> {
  light: Light;
}

export interface MaybeAggregatedHeatProfile
  extends Omit<HeatProfileDtoV1, 'light'> {
  light: Light | MoodLightDto;
}

export const isColorLight = (
  light: ColorLight | MoodLightId | MoodLightDto,
): light is ColorLight => (light as ColorLight).color !== undefined;

export const isMoodLightId = (
  light: ColorLight | MoodLightId,
): light is MoodLightId => !!(light as MoodLightId).id;

export const isMoodLightDto = (
  light: ColorLight | MoodLightDto | MoodLightId,
): light is MoodLightDto => !!(light as MoodLightDto).projector;

export const getHeatProfileMoodLight =
  (store: Record<string, MoodLightDto>) =>
  (heatProfile?: MaybeAggregatedHeatProfile) => {
    if (!heatProfile) return;

    if (isMoodLightDto(heatProfile.light)) return heatProfile.light;

    if (isMoodLightId(heatProfile.light))
      return store[heatProfile.light.id] as MoodLightDto | undefined;
  };

export const getHeatProfileLight =
  (store: Record<string, MoodLightDto>) =>
  (heatProfile?: MaybeAggregatedHeatProfile) => {
    if (!heatProfile) return {color: '#ffffff'};

    if (isMoodLightDto(heatProfile.light)) return heatProfile.light;

    if (isMoodLightId(heatProfile.light))
      return store[heatProfile.light.id] as MoodLightDto | undefined;

    return heatProfile.light;
  };

export const getColors = (light?: ColorLight | MoodLightDto) => {
  if (!light) return ['#ffffff'];

  if (isColorLight(light)) return [light.color];

  return light.projector.meta.userColors ?? ['#ffffff'];
};

export const getHeatProfileColors =
  (store: Record<string, MoodLightDto>) =>
  (heatProfile?: MaybeAggregatedHeatProfile) => {
    const light = getHeatProfileLight(store)(heatProfile);

    return getColors(light);
  };
